import { render, staticRenderFns } from "./ClientInformationTab.vue?vue&type=template&id=09553a87&"
import script from "./ClientInformationTab.vue?vue&type=script&lang=js&"
export * from "./ClientInformationTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports